export const customersThunkNames = {
    fetchCustomers: 'fetchCustomers',
    fetchCustomer: 'fetchCustomer',
    fetchCustomerBillingDetails: 'fetchCustomerBillingDetails',
    fetchCustomerBillingHistory: 'fetchCustomerBillingHistory',
    fetchCustomerSubscriptions: 'fetchCustomerSubscriptions',
    changeCustomerSubscription: 'changeCustomerSubscription',
};
